var _excluded = ["icon", "theme", "small"];

var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { forwardRef } from 'react';
import { oneOfType, func, node, bool } from 'prop-types';
import styled, { withTheme } from 'styled-components';
import StyledButton from './StyledButton';
import Icon from '../../Icon';
var IconStyled = styled(StyledButton)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0;\n\n  svg {\n    width: unset;\n    height: unset;\n    margin-right: unset;\n\n    transition: fill 0.2s;\n  }\n\n  ", "\n"])), function (_ref) {
  var small = _ref.small,
      button = _ref.theme.yoga.components.button;
  return "\n    width: " + (small ? button.height.small : button.height["default"]) + "px;\n  ";
});
var ButtonIcon = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var icon = _ref2.icon,
      button = _ref2.theme.yoga.components.button,
      small = _ref2.small,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(IconStyled, _extends({}, props, {
    ref: ref,
    small: small
  }), /*#__PURE__*/React.createElement(Icon, {
    as: icon,
    size: small ? button.icon.size.small : button.icon.size["default"]
  }));
});
ButtonIcon.propTypes = {
  small: bool,
  disabled: bool,
  secondary: bool,
  inverted: bool,
  icon: oneOfType([node, func])
};
ButtonIcon.defaultProps = {
  small: false,
  disabled: false,
  secondary: false,
  inverted: false,
  icon: undefined
};
ButtonIcon.displayName = 'Button.Icon';
export default withTheme(ButtonIcon);